import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { confirmUnconfirmUserService, createUserService, deleteUserService, updateUserService } from '../../../services/adminServices';

import { CreateUserArgs, InitialState } from 'MyAccountPlus-UIComponents';

const initialState: InitialState = {
    loading: false,
    error: "",
    success: "",
};

export const createUserThunk = createAsyncThunk("userList/createUserThunk", async (args: CreateUserArgs) => {
    try {
        const { data } = await createUserService(args);
        return { data }
    } catch (error: any) {
        console.log("error--", error);
        throw new Error(error);
    }
});

export const updateUserThunk = createAsyncThunk("userList/updateUserThunk", async (args: CreateUserArgs) => {
    try {
        const { data } = await updateUserService(args);
        return { data }
    } catch (error: any) {
        console.log("error--", error);
        throw new Error(error);
    }
});

export const deleteUserThunk = createAsyncThunk("userList/deleteUserThunk", async (args: string) => {
    try {
        const { data } = await deleteUserService(args);
        return { data }
    } catch (error: any) {
        console.log("error--", error);
        throw new Error(error);
    }
});

export const confirmUnconfirmUserThunk = createAsyncThunk("userList/confirmUnconfirmUserThunk", async (args: string) => {
    try {
        const { data } = await confirmUnconfirmUserService(args);
        return { data }
    } catch (error: any) {
        console.log("error--", error);
        throw new Error(error);
    }
});

export const userListsSlice = createSlice({
    name: 'userList',
    initialState,
    reducers: {
        errorReducer: (state) => {
            state.error = ""
        },
        successReducer: (state) => {
            state.success = ""
        },
        clearState: (state) => {
            return initialState
        }
    },
    extraReducers(builder) {
        builder
            .addCase(createUserThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(createUserThunk.fulfilled, (state, action) => {
                state.success = "User created successfully!"
                state.loading = false
                state.error = ""
            })
            .addCase(createUserThunk.rejected, (state, action) => {
                state.error = action.error.message! + " User may already exist.  Please verify the data"
                state.loading = false
            })
            .addCase(updateUserThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(updateUserThunk.fulfilled, (state, action) => {
                state.success = "User updated successfully!"
                state.loading = false
                state.error = ""
            })
            .addCase(updateUserThunk.rejected, (state, action) => {
                state.error = action.error.message! + " User may already exist. Please verify the data!"
                state.loading = false
            })
            .addCase(deleteUserThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(deleteUserThunk.fulfilled, (state, action) => {
                state.success = "User deleted successfully!"
                state.loading = false
                state.error = ""
            })
            .addCase(deleteUserThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(confirmUnconfirmUserThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(confirmUnconfirmUserThunk.fulfilled, (state, action) => {
                state.success = "User confirmed!"
                state.loading = false
                state.error = ""
            })
            .addCase(confirmUnconfirmUserThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
    },
});

export const usersListActions = userListsSlice.actions;
export default userListsSlice.reducer;